/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cm: NonNullable<unknown> }} Commutator_InInputs */



/**
* | output |
* | --- |
* | "Switch in {cm}" |
*
* @param {Commutator_InInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const commutator_in = /** @type {((inputs: Commutator_InInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commutator_InInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Switch in ${i?.cm}`)
	return /** @type {LocalizedString} */ (`Commutateur en ${i?.cm}`)
});